import _ from 'lodash';
import React from 'react';

export const CompanyLabel = function(props) {
  const getLabel = () => {
    if (!props.company) return null;

    let label = _.find(props?.company?.properties, prop => prop?.name?.name === 'name')?.value;

    if (props.withSurname) {
      label = `${_.find(props?.company?.properties, prop => prop?.name?.name === 'name')?.value ?? ''} ${_.find(
        props?.company?.properties,
        prop => prop?.name?.name === 'surname',
      )?.value ?? ''}`;
    }

    return label;
  };

  return (
    <span className="company-label">
      {/* {props?.company
        ? `${_.find(props?.company?.properties, prop => prop?.name?.name === 'name')?.value} ${
            _.find(props?.company?.properties, prop => prop?.name?.name === 'surname')?.value
          }`
        : null} */}

      {getLabel()}
    </span>
  );
};
